<script lang="ts">
    import Fa from 'svelte-fa'
    import { FormTemplateItem } from '../../../modules/toolsApi/forms/form-templates/form-template-item'
    import { faClone, faCaretLeft, faCheck, faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import Signature from '../../_common/Signature.svelte'
    import { FormDataContent } from '../../../modules/toolsApi/forms/form-datas/form-data-content'
    import Content from '../../_common/content.svelte'
    import type { FormDataMetadata } from '../../../modules/toolsApi/forms/form-datas/form-data'
    let dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let item: FormTemplateItem
    export let editable: boolean
    export let value: FormDataContent = new FormDataContent()
    export let isNew: boolean = false
    export let view = false
    export let hash: string = null
    export let metadata: FormDataMetadata = null

    let step = 1
    let locallabel = ''
    let localLocked = false

    function emitChange() {
        dispatch('change')
    }

    function goEdit() {
        locallabel = item.label || ''
        localLocked = item.locked
        step = 2
        dispatch('edit', true)
    }

    function goRemove() {
        item = null
        dispatch('remove')
    }

    function goCancel() {
        dispatch('edit', false)
        step = 1
    }

    onMount(() => {
        if (isNew) {
            goEdit()
        }
    })

    function goSave() {
        item.label = locallabel
        item.locked = localLocked
        item.score = false
        dispatch('edit', false)
        dispatch('change')
        step = 1
    }

    function goClone() {
        dispatch('clone', item)
    }
</script>

<div class="cs_element cs_input_line cs_element-editable-{editable} {className}" class:draggable={step === 1}>
    {#if step === 1}
        {#if editable}
            <div class="acts acts_1 acts-absolute">
                <div class="spacer"></div>
                <button on:click={goClone} title="Clique para duplicar este elemento" class="btn btn-sm btn-secondary me-2"><Fa icon={faClone}></Fa></button>
                <button on:click={goEdit} class="btn btn-sm btn-warning"><Fa icon={faEdit}></Fa></button>
            </div>
        {/if}
    {:else}
        <div class="acts acts_2 acts-absolute">
            <div class="spacer"></div>
            <div class="btn-group">
                <button on:click={goRemove} class="btn btn-sm btn-warning"><Fa icon={faTrash}></Fa>&nbsp;Excluir</button>
                {#if !isNew}
                    <button on:click={goCancel} class="btn btn-sm btn-secondary"><Fa icon={faCaretLeft}></Fa>&nbsp;Cancelar</button>
                {/if}
                <button on:click={goSave} class="btn btn-sm btn-primary"><Fa icon={faCheck}></Fa>&nbsp;Confirmar</button>
            </div>
        </div>
    {/if}

    {#if step === 1}
        <div class="cs_element_content">
            <div class="content_answer">
                {#if value.value?.includes('https://') || view}
                    <div class="content-label mt-2 sign-img">
                        <img src={value.value} title="" alt="" />
                        <div>{item.label}</div>
                    </div>
                    {#if hash}
                        <div class="cs_input_line_sign-metadata">
                            Hash do documento assinado:{hash}.<br />
                            {#if metadata}
                                Carimbo de data e hora da assinatura: {metadata?.time}.<br />
                                IP do dispositivo utilizado: {metadata?.requestIP?.split(',')[0]}.<br />
                                Dados do dispositivo: {metadata?.userAgent}.<br />
                            {/if}
                        </div>
                    {/if}
                {:else}
                    <div class="content-label mt-2">
                        <Signature bind:image={value.value} on:change={emitChange} label="Assine com o dedo/mouse" />
                        <div>{item.label}</div>
                    </div>
                {/if}
            </div>
        </div>
    {:else}
        <label for="" class="cs_item_title edit_question">Texto abaixo do campo de assinatura</label>
        <div class="input-inline">
            <input type="text" bind:value={locallabel} class="" />
            <div class="form-check form-switch cs-w-150">
                <input class="form-check-input" bind:checked={localLocked} type="checkbox" role="switch" id="localLocked" />
                <label class="form-check-label" for="localLocked">Apenas leitura</label>
            </div>
        </div>
    {/if}
</div>
